import Api from "../axios";

export const loginApi = async (data) => {
    return await Api.post("Token/Authenticate",data)
};
